/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import styles from "./styles.module.scss";
import { IoPeopleOutline } from "react-icons/io5";
import Loading from "../../../home/components/Loading";

import IsValidEmail from "../../../../utils/validators/IsValidEmail";
import InputForm from "../../../../components/InputForm";
import IsValidPhone from "../../../../utils/validators/IsValidPhone";
import verifyCpfCnpj from "../../../../utils/validators/IsValidCpfCnpj";
import validateCep from "../../../../utils/validators/IsValidCep";
import formatTel from "../../../../utils/FormatTel";
import formatDocument from "../../../../utils/FormatDocument";
import FormActions from "../../components/FormActions";
import { AppAPIService } from "../../../../services/AppAPIService";
import Swal from "sweetalert2";
import store from "../../../../store/store";
import axios from "axios";
import { Grid } from "@material-ui/core";
import moment from "moment";
// import { useProtectedPage } from "../../../../hooks/useProtectedPage";
// import { USER_TYPES } from "../../../../enum/ClientTypes";

const ClientForm = () => {
  // useProtectedPage(USER_TYPES.USERS_PROFILES.WRITE.name);

  let api = AppAPIService.getInstance();
  const history = useHistory();
  const { auth } = store.getState();

  const pessoaTypeOptions = [
    { value: "FISICA", label: "Pessoa Física" },
    { value: "JURIDICA", label: "Pessoa Jurídica" },
  ];
  const [pessoaType, setPessoaType] = useState();
  const [pessoaTypeRole, setPessoaTypeRole] = useState("ok");
  const [pessoaTypeError, setPessoaTypeError] = useState("");
  const handleInputPessoaType =(e) => {
    if (!e) {
      setPessoaTypeError("Campo obrigatório");
      setPessoaTypeRole("notOk");
    } else {
      setPessoaType(e);
      setPessoaTypeError("");
      setPessoaTypeRole("ok");
    }
  };

  const [loading, setLoading] = useState(false);
  const [states, setUfs] = useState([]);
  const [cities, setCities] = useState([]);
  /*name*/
  const [name, setName] = useState("");
  const [nameRole, setNameRole] = useState("");
  const [nameError, setNameError] = useState("");
  const handleInputName = (name) => {
    if (!name) {
      setName();
      setNameError("Campo obrigatório");
      setNameRole("notOk");
    } else {
      setName(name);
      setNameError("");
      setNameRole("ok");
    }
  };
  /* end name*/

  /*phone*/
  const [phone, setPhone] = useState("");
  const [phoneRole, setPhoneRole] = useState("ok");
  const [phoneError, setPhoneError] = useState(""); 

  const handleInputPhone = useCallback((e) => {
    if (e.length > 11) {
      return;
    }
    if (!IsValidPhone(e)) {
      setPhone(e);
      setPhoneError("Não é um telefone válido.");
      setPhoneRole("notOk");
    } else {
      setPhone(formatTel(e));
      setPhoneError("");
      setPhoneRole("ok");
    }
  }, []);
  /* end phone*/

  /*cpf*/
  const [cpf, setCpf] = useState("");
  const [cpfRole, setCpfRole] = useState("ok");
  const [cpfError, setCpfError] = useState("");
  const handleInputCpf = useCallback((e) => {
    if (e.length > 18) {
      return;
    }
    if (e.length < 1) {
      setCpf(e);
      setCpfError("CPF/CNPJ Obrigatório");
      setCpfRole("notOk");
    } else if (!verifyCpfCnpj(e)) {
      setCpf(e);
      setCpfError("Não é um CPF válido.");
      setCpfRole("notOk");
    } else {
      setCpf(formatDocument(e));
      setCpfError("");
      setCpfRole("ok");
    }
  }, []);


  /* end cpf*/

  /*email*/
  const [email, setEmail] = useState("");
  const [emailRole, setEmailRole] = useState("");
  const [emailError, setEmailError] = useState("");
  const handleInputEmail = useCallback((e) => {
    if (e.length > 50) {
      return;
    }
    if (e.length < 1) {
      setEmail(e);
      setEmailError("Campo obrigatório");
      setEmailRole("notOk");
    } else if (!IsValidEmail(e)) {
      setEmail(e);
      setEmailError("Não é um E-mail válido.");
      setEmailRole("notOk");
    } else {
      setEmail(e);
      setEmailError("");
      setEmailRole("ok");
    }
  }, []);
  /* end email*/

  /* otherPhone01 */
  const [otherPhone01, setOtherPhone01] = useState("");
  const [otherPhone01Role, setOtherPhone01Role] = useState("");
  const [otherPhone01Error, setOtherPhone01Error] = useState("");
  const handleInputOtherPhone01 = useCallback((e) => {
    console.log("e", e);
    if (e.length < 1) {
      setOtherPhone01(e);
      setOtherPhone01Error("");
      setOtherPhone01Role("ok");
      return
    } else if (!IsValidPhone(e)) {
      setOtherPhone01(e);
      setOtherPhone01Error("Não é um telefone válido.");
      setOtherPhone01Role("notOk");
    } else {
      setOtherPhone01(formatTel(e));
      setOtherPhone01Error("");
      setOtherPhone01Role("ok");
    }
  }, []);
  /* end otherPhone01 */

  /* otherPhone02 */
  const [otherPhone02, setOtherPhone02] = useState("");
  const [otherPhone02Role, setOtherPhone02Role] = useState("");
  const [otherPhone02Error, setOtherPhone02Error] = useState("");
  const handleInputOtherPhone02 = useCallback((e) => {
    console.log("e", e);
    if (e.length < 1) {
      setOtherPhone02(e);
      setOtherPhone02Error("");
      setOtherPhone02Role("ok");
      return
    } else if (!IsValidPhone(e)) {
      setOtherPhone02(e);
      setOtherPhone02Error("Não é um telefone válido.");
      setOtherPhone02Role("notOk");
    } else {
      setOtherPhone02(formatTel(e));
      setOtherPhone02Error("");
      setOtherPhone02Role("ok");
    }
  }, []);
  /* end otherPhone02 */

  /* responsavel */
  const [responsavel, setResponsavel] = useState("");
  const [responsavelRole, setResponsavelRole] = useState("");
  const [responsavelError, setResponsavelError] = useState("");
  const handleInputResponsavel = useCallback((e) => {
    console.log("e", e);
    if (e.length < 1) {
      setResponsavel(e);
      setResponsavelError("");
      setResponsavelRole("ok");
      return
    } else {
      setResponsavel(e);
      setResponsavelError("");
      setResponsavelRole("ok");
    }
  }, []);
  /* end responsavel */

  /* nascimento */
  const [nascimento, setNascimento] = useState("");
  const [nascimentoRole, setNascimentoRole] = useState("");
  const [nascimentoError, setNascimentoError] = useState("");
  const handleInputNascimento = useCallback((e) => {
    console.log("e", e);
    if (e.length < 1) {
      setNascimento(e);
      setNascimentoError("");
      setNascimentoRole("ok");
      return
    } else {
      setNascimento(e);
      setNascimentoError("");
      setNascimentoRole("ok");
    }
  }, []);
  /* end nascimento */

  /* contato01 */
  const [contato01, setContato01] = useState("");
  const [contato01Role, setContato01Role] = useState("");
  const [contato01Error, setContato01Error] = useState("");
  const handleInputContato01 = useCallback((e) => {
    console.log("e", e);
    if (e.length < 1) {
      setContato01(e);
      setContato01Error("");
      setContato01Role("ok");
      return
    } else {
      setContato01(e);
      setContato01Error("");
      setContato01Role("ok");
    }
  }, []);
  /* end contato01 */

  /* email01 */
  const [email01, setEmail01] = useState("");
  const [email01Role, setEmail01Role] = useState("");
  const [email01Error, setEmail01Error] = useState("");
  const handleInputEmail01 = useCallback((e) => {
    console.log("e", e);
    if (e.length < 1) {
      setEmail01(e);
      setEmail01Error("");
      setEmail01Role("ok");
      return
    } else {
      setEmail01(e);
      setEmail01Error("");
      setEmail01Role("ok");
    }
  }, []);
  /* end email01 */

  /* contato02 */
  const [contato02, setContato02] = useState("");
  const [contato02Role, setContato02Role] = useState("");
  const [contato02Error, setContato02Error] = useState("");
  const handleInputContato02 = useCallback((e) => {
    console.log("e", e);
    if (e.length < 1) {
      setContato02(e);
      setContato02Error("");
      setContato02Role("ok");
      return
    } else {
      setContato02(e);
      setContato02Error("");
      setContato02Role("ok");
    }
  }, []);
  /* end contato02 */

  /* email02 */
  const [email02, setEmail02] = useState("");
  const [email02Role, setEmail02Role] = useState("");
  const [email02Error, setEmail02Error] = useState("");
  const handleInputEmail02 = useCallback((e) => {
    console.log("e", e);
    if (e.length < 1) {
      setEmail02(e);
      setEmail02Error("");
      setEmail02Role("ok");
      return
    } else {
      setEmail02(e);
      setEmail02Error("");
      setEmail02Role("ok");
    }
  }, []);
  /* end email02 */

  /** get states */
  const handleSetUfs = useCallback(async () => {
    try {
      const response = await (
        await axios.get(
          "https://servicodados.ibge.gov.br/api/v1/localidades/estados"
        )
      ).data;
      const ufOpts = response.map(resp => ({
        value: resp.sigla,
        label: resp.nome
      }));
      setUfs(ufOpts);
    } catch (error) {
      console.error(error);
    }
  }, []);

  /** consulta CEP */
  const handleCepConsult = useCallback(
    async cep => {
      try {
        setLoading(true);
        let response = await (
          await axios.get(`https://viacep.com.br/ws/${cep}/json`, {
            headers: {}
          })
        ).data;

        if (response?.erro) {
          setPostalCodeRole("ok");
          setPostalCodeError("");

          setRouteAddress("");
          setRouteAddressRole("notOk");
          setRouteAddressError("Campo obrigatório.");

          setDistrict("");
          setDistrictRole("notOk");
          setDistrictError("Campo obrigatório.");

          setComplement("");
          setComplementRole("");
          setComplementError("");

          setStreetNumber("");
          setStreetNumberRole("");
          setStreetNumberError("");

          setState("");
          setStateRole("notOk");
          setStateError("Campo obrigatório.");

          setCity("");
          setCityRole("notOk");
          setCityError("Campo obrigatório.");

          handleSetUfs();

          throw new Error("Não foi possível encontrar o CEP digitado.");
        }

        setPostalCodeRole("ok");
        setPostalCodeError("");

        setRouteAddress(response.logradouro);
        setRouteAddressRole("ok");
        setRouteAddressError("");

        if (!response.logradouro) {
          setRouteAddressRole("notOk");
        }

        setDistrict(response.bairro);
        setDistrictRole("ok");
        setDistrictError("");

        if (!response.bairro) {
          setDistrictRole("notOk");
        }

        setState({
          value: response.uf,
          label: response.uf
        });
        setStateRole("ok");
        setStateError("");

        setCity({
          value: response.localidade,
          label: response.localidade
        });
        setCityRole("ok");
        setCityError("");
      } catch (error) {
        console.error(error);

        Swal.fire({
          icon: "error",
          title: "CEP não encontrado",
          text: "Por favor, verifique o CEP inserido."
        });
      } finally {
        setLoading(false);
      }
    },
    [handleSetUfs]
  );

  /*postalCode*/
  const [postalCode, setPostalCode] = useState("");
  const [postalCodeRole, setPostalCodeRole] = useState("");
  const [postalCodeError, setPostalCodeError] = useState("");
  const handleInputPostalCode = useCallback(
    async postalCode => {
      if (postalCode.length > 11 || postalCode.length < 1) {
        return;
      }

      const { error, cepFormat, cep, role } = validateCep(postalCode);

      if (postalCode.length < 1) {
        setPostalCode(postalCode);
        setPostalCodeError("Campo obrigatório.");
        setPostalCodeRole("notOk");
        return;
      }

      if (cep === "") {
        setPostalCodeError("Apenas números.");
        setPostalCodeRole("notOk");
        return;
      }

      if (postalCode.length > 10) {
        return;
      }

      setPostalCode(cepFormat);
      setPostalCodeError(error);
      setPostalCodeRole(role);

      if (cep.length === 8) {
        await handleCepConsult(cep);
      }
    },
    [handleCepConsult]
  );
  /* end postalCode*/

  /*routeAddress*/
  const [routeAddress, setRouteAddress] = useState("");
  const [routeAddressRole, setRouteAddressRole] = useState("");
  const [routeAddressError, setRouteAddressError] = useState("");
  const handleInputRouteAddress = (e) => {
    if (e.length < 1) {
      setRouteAddress();
      setRouteAddressError("");
      setRouteAddressRole("ok");
      return
    } else {
      setRouteAddress(e);
      setRouteAddressError("");
      setRouteAddressRole("ok");
    }
  };
  /* end routeAddress*/

  /*district*/
  const [district, setDistrict] = useState("");
  const [districtRole, setDistrictRole] = useState("");
  const [districtError, setDistrictError] = useState("");
  const handleInputDistrict = (e) => {
    if (e.length < 1) {
      setDistrict();
      setDistrictError(null);
      setDistrictRole("ok");
      return
    } else {
      setDistrict(e);
      setDistrictError(null);
      setDistrictRole("ok");
    }
  };
  /* end district*/

  /*streetNumber*/
  const [streetNumber, setStreetNumber] = useState("");
  const [streetNumberRole, setStreetNumberRole] = useState("");
  const [streetNumberError, setStreetNumberError] = useState("");
  const handleInputStreetNumber = (e) => {
    if (e.length < 1) {
      setStreetNumber();
      setStreetNumberError(null);
      setStreetNumberRole("ok");
      return
    } else {
      setStreetNumber(e);
      setStreetNumberError(null);
      setStreetNumberRole("ok");
    }
  };
  /* end streetNumber*/

  /* complement */
  const [complement, setComplement] = useState("");
  const [complementRole, setComplementRole] = useState("");
  const [complementError, setComplementError] = useState("");
  const handleInputComplement = (e) => {
    if (e.length < 1) {
      setComplement();
      setComplementError("");
      setComplementRole("ok");
      return
    } else {
      setComplement(e);
      setComplementError("");
      setComplementRole("ok");
    }
  };
  /* end complement*/

  /* city */
  const [city, setCity] = useState("");
  const [cityRole, setCityRole] = useState("");
  const [cityError, setCityError] = useState("");
  const handleInputCity = (e) => {
    if (e.length < 1) {
      setCity();
      setCityError("");
      setCityRole("ok");
      return
    } else {
      setCity(e);
      setCityError("");
      setCityRole("ok");
    }
  };
  /* end city*/

  /* state */
  const [state, setState] = useState("");
  const [stateRole, setStateRole] = useState("");
  const [stateError, setStateError] = useState("");
  const handleInputState = (e) => {
    if (e.length < 1) {
      setState();
      setStateError("");
      setStateRole("ok");
      return
    } else {
      setState(e);
      setStateError("");
      setStateRole("ok");
    }
  };
  /* end state*/

  /** get cities */
  const handleSetCities = useCallback(async () => {
    try {
      const ufSelected = states.find(ufOpt => ufOpt.value === state?.value);
      const response = await (
        await axios.get(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${ufSelected?.value}/municipios`
        )
      ).data;
      const ufOpts = response.map(resp => ({
        value: resp.nome,
        label: resp.nome
      }));
      setCities(ufOpts);
    } catch (error) {
      console.log(error);
    }
  }, [state.value, states]);

  /* form validation */
  const formIsValid = useCallback(() => {
    let validForm = true;

    validForm =
      name !== "" &&
      nameRole === "ok" &&
      email !== "" &&
      IsValidEmail(email) &&
      emailRole === "ok" && 
      cpf !== "" && 
      cpfRole === "ok" && 
      phone !== "" && 
      phoneRole === "ok"

    return validForm;
  }, [name, nameRole, email, emailRole, cpf, cpfRole, phone, phoneRole]);

  /* end form validation */
  /* submit */
  const submit = useCallback(
    async (e) => {
      setLoading(true);
      e.preventDefault();
      try {
        setLoading(true);
        await api.makeHttpRequest({
          url: `/client`,
          method: "POST",
          data: {
            name,
            email,
            document: cpf,
            responsiblePhone: phone,
            otherPhone01,
            otherPhone02,
            postalCode,
            routeAddress,
            district,
            streetNumber: Number(streetNumber),
            complement,
            city: city.label,
            state: state.label,
            pessoaType: pessoaType.value,
            responsavel,
            nascimento: moment(nascimento + '00:01').format('YYYY-MM-DD'),
            contato01,
            email01,
            contato02,
            email02,
            isCnpj: cpf.replace(/[./-]/g, "").length > 11 ? 'CNPJ' : 'CPF'
          },
        });
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text:
            "Cliente criado com sucesso."
        }).then(() => {
          history.push("/admin/cliente");
        });
      } catch (error) {
        setLoading(false);
        console.log(error.response);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Erro ao criar cliente.",
        });
      } finally {
        setLoading(false);
      }
    },
    [name, email, history, api, auth.token, auth.user, phone, cpf, postalCode, routeAddress, streetNumber, complement, city, state, pessoaType, responsavel, nascimento, contato01, email01, contato02, email02]
  );
  /* end submit */
  
  useEffect(() => {
    handleSetUfs();
  }, [handleSetUfs]);

  useEffect(() => {
    handleSetCities();
  }, [states, state.value, handleSetCities]);

  /* clean form */
  const onCleanForm = async () => {
    setName("");
    setEmail("");
    setCpf("");
    setPhone("");
    setOtherPhone01("");
    setOtherPhone02("");
    setStreetNumber(null);
    setPostalCode("");
    setDistrict("");
    setRouteAddress("");
    setComplement("");
    setCity("");
    setState("");
    setPessoaType("");
    setResponsavel("");
    setNascimento("");
    setContato01("");
    setEmail01("");
    setContato02("");
    setEmail02("");
  };
  /* end clean form */

  useEffect(() => {
    handleSetCities();
  }, [handleSetCities]);

  return (
    <div className={styles.container}>
      <Loading isLoading={loading} />
      <span className={styles.formTitle}>
        {" "}
        <IoPeopleOutline /> Cadastrar Cliente
      </span>

      <form className={styles.form} autoComplete="off">
        <div className={styles.containerInputs}>
          <Grid container spacing={1}>
            <Grid item md={4}>
                <InputForm
                  type="text"
                  name="cpf"
                  placeholder="Digite o CPF ou CNPJ"
                  label={"CPF/CNPJ *"}
                  value={cpf}
                  error={cpfError}
                  onChange={handleInputCpf}
                  role={cpfRole}
                />
            </Grid>
            <Grid item md={2}>
              <InputForm
                isSelect
                placeholder="Tipo de Pessoa"
                label="Tipo de Pessoa"
                role={pessoaTypeRole}
                value={pessoaType}
                options={pessoaTypeOptions}
                onChange={handleInputPessoaType}
                error={pessoaTypeError}
              />
            </Grid>
            <Grid item md={6}>
              <InputForm
                type="text"
                name="name"
                placeholder="Digite a razão social ou nome completo"
                label={"Razão Social/Nome *"}
                value={name}
                onChange={handleInputName}
                error={nameError}
                role={nameRole}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <Grid container spacing={1}>
            <Grid item md={4}>
              <InputForm
                type="text"
                name="responsavel"
                placeholder="Digite o nome completo"
                label={"Responsável"}
                value={responsavel}
                error={responsavelError}
                onChange={handleInputResponsavel}
                role={responsavelRole}
              />
            </Grid>
            <Grid item md={4}>
              <InputForm
                type="email"
                name="email"
                placeholder="Digite o e-mail"
                label={"E-mail *"}
                value={email}
                error={emailError}
                onChange={handleInputEmail}
                role={emailRole}
              />
            </Grid>
            <Grid item md={2}>
              <InputForm
                type="phone"
                name="phone"
                placeholder="Digite o número"
                label={"Telefone/Celular *"}
                value={phone}
                error={phoneError}
                onChange={handleInputPhone}
                role={phoneRole}
              />
            </Grid>
            <Grid item md={2}>
              <InputForm
                type="date"
                name="nascimento"
                placeholder="Selecione a data"
                label={"Nascimento"}
                value={nascimento}
                error={nascimentoError}
                onChange={handleInputNascimento}
                role={nascimentoRole}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <InputForm
            type="phone"
            name="postalCode"
            placeholder="Digite o CEP"
            label={"CEP"}
            value={postalCode}
            error={postalCodeError}
            onChange={handleInputPostalCode}
            role={postalCodeRole}
          />
          <InputForm
            isSelect
            placeholder="Selecione o estado"
            label="Estado"
            role={stateRole}
            value={state}
            options={states}
            onChange={handleInputState}
            error={stateError}
          />
          <InputForm
            isSelect
            placeholder="Selecione a cidade"
            label="Cidade"
            role={cityRole}
            value={city}
            options={cities}
            onChange={handleInputCity}
            error={cityError}
          />
        </div>
        <div className={styles.containerInputs}>
          <Grid container spacing={1}>
            <Grid item md={4}>
              <InputForm
                type="text"
                name="routeAddress"
                placeholder="Digite o logradouro (rua, avenida, praça, etc)"
                label={"Endereço"}
                value={routeAddress}
                error={routeAddressError}
                onChange={handleInputRouteAddress}
                role={routeAddressRole}
              />
            </Grid>
            <Grid item md={2}>
              <InputForm
                type="phone"
                name="streetNumber"
                placeholder="Digite o número"
                label={"Número"}
                value={streetNumber}
                error={streetNumberError}
                onChange={handleInputStreetNumber}
                role={streetNumberRole}
              />
            </Grid>
            <Grid item md={2}>
              <InputForm
                type="text"
                name="complement"
                placeholder="Digite o complemento"
                label={"Complemento"}
                value={complement}
                error={complementError}
                onChange={handleInputComplement}
                role={complementRole}
              />
            </Grid>
            <Grid item md={4}>
              <InputForm
                type="text"
                name="district"
                placeholder="Digite o bairro"
                label={"Bairro"}
                value={district}
                error={districtError}
                onChange={handleInputDistrict}
                role={districtRole}
              />
            </Grid>
          </Grid>
        </div>
        <div className={styles.containerInputs}>
          <InputForm
            type="text"
            name="contato01"
            placeholder="Digite o nome completo"
            label={"Contato 1"}
            value={contato01}
            error={contato01Error}
            onChange={handleInputContato01}
            role={contato01Role}
          />
          <InputForm
            type="email"
            name="email01"
            placeholder="Digite o e-mail"
            label={"E-mail 1"}
            value={email01}
            error={email01Error}
            onChange={handleInputEmail01}
            role={email01Role}
          />
          <InputForm
            type="phone"
            name="otherPhone01"
            placeholder="Digite outro Telefone"
            label={"Telefone/Celular 1"}
            value={otherPhone01}
            error={otherPhone01Error}
            onChange={handleInputOtherPhone01}
            role={otherPhone01Role}
          />
        </div>
        <div className={styles.containerInputs}>
          <InputForm
            type="text"
            name="contato02"
            placeholder="Digite o nome completo"
            label={"Contato 1"}
            value={contato02}
            error={contato02Error}
            onChange={handleInputContato02}
            role={contato02Role}
          />
          <InputForm
            type="email"
            name="email02"
            placeholder="Digite o e-mail"
            label={"E-mail 1"}
            value={email02}
            error={email02Error}
            onChange={handleInputEmail02}
            role={email02Role}
          />
          <InputForm
            type="phone"
            name="otherPhone02"
            placeholder="Digite outro Telefone"
            label={"Telefone 2"}
            value={otherPhone02}
            error={otherPhone02Error}
            onChange={handleInputOtherPhone02}
            role={otherPhone02Role}
          />
        </div>
      </form>

      <FormActions
        module={"cliente"}
        formIsValid={formIsValid()}
        onCleanForm={onCleanForm}
        onSubmit={submit}
        hideCancel={true}
        messagem
      />
    </div>
  );
};
export default ClientForm;
